interface IProps {
  width?: number;
  height?: number;
  fill?: string;
}

export const EditIcon = ({
  width = 24,
  height = 24,
  fill = "#16151C",
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={"cursor-pointer"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 21H21M13.7844 5.31171C13.7844 5.31171 13.7844 6.94634 15.419 8.58096C17.0537 10.2156 18.6883 10.2156 18.6883 10.2156M7.31963 17.9881L10.7523 17.4977C11.2475 17.4269 11.7064 17.1975 12.06 16.8438L20.3229 8.58096C21.2257 7.67818 21.2257 6.21449 20.3229 5.31171L18.6883 3.67708C17.7855 2.77431 16.3218 2.77431 15.419 3.67708L7.15616 11.94C6.80248 12.2936 6.57305 12.7525 6.50231 13.2477L6.01193 16.6804C5.90295 17.4432 6.5568 18.097 7.31963 17.9881Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const TrashIcon = ({
  width = 20,
  height = 22,
  fill = "#16151C",
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 22"
      fill="none"
      className={"cursor-pointer"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 8L16.2841 17.3068C16.1238 19.3908 14.386 21 12.2959 21H7.70412C5.61398 21 3.87621 19.3908 3.71591 17.3068L3 8M19 6C16.4021 4.73398 13.3137 4 10 4C6.68635 4 3.59792 4.73398 1 6M8 4V3C8 1.89543 8.89543 1 10 1C11.1046 1 12 1.89543 12 3V4M8 10V16M12 10V16"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const NotePadIcon = ({
  width = 22,
  height = 22,
  fill = "#16151C",
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        d="M8 10H16M8 14H16M8 18H12M8 4C8 5.10457 8.89543 6 10 6H14C15.1046 6 16 5.10457 16 4M8 4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4M8 4H7C4.79086 4 3 5.79086 3 8V18C3 20.2091 4.79086 22 7 22H17C19.2091 22 21 20.2091 21 18V8C21 5.79086 19.2091 4 17 4H16"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};
